import {
  ACRONYMS as ACRONYMS_AIGP,
  GLOSSARY as GLOSSARY_AIGP,
  FLASHCARDS as FLASHCARDS_AIGP,
  QUESTIONS as QUESTIONS_AIGP,
  ARTICLES as ARTICLES_AIGP
} from  './aigp'

import {
  ACRONYMS as ACRONYMS_AWSCAIP,
  GLOSSARY as GLOSSARY_AWSCAIP,
  FLASHCARDS as FLASHCARDS_AWSCAIP,
  QUESTIONS as QUESTIONS_AWSCAIP,
  ARTICLES as ARTICLES_AWSCAIP
} from  './awscaip'

import {
  ACRONYMS as ACRONYMS_AWSMLE,
  GLOSSARY as GLOSSARY_AWSMLE,
  FLASHCARDS as FLASHCARDS_AWSMLE,
  QUESTIONS as QUESTIONS_AWSMLE,
  ARTICLES as ARTICLES_AWSMLE
} from  './awsmle'

import {
  ACRONYMS as ACRONYMS_GHCPC,
  GLOSSARY as GLOSSARY_GHCPC,
  FLASHCARDS as FLASHCARDS_GHCPC,
  QUESTIONS as QUESTIONS_GHCPC,
  ARTICLES as ARTICLES_GHCPC
} from  './ghcpc'

import {
  ACRONYMS as ACRONYMS_SECAIPLUS,
  GLOSSARY as GLOSSARY_SECAIPLUS,
  FLASHCARDS as FLASHCARDS_SECAIPLUS,
  QUESTIONS as QUESTIONS_SECAIPLUS,
  ARTICLES as ARTICLES_SECAIPLUS
} from  './secaiplus'

import {
  ACRONYMS as ACRONYMS_DATAAI,
  GLOSSARY as GLOSSARY_DATAAI,
  FLASHCARDS as FLASHCARDS_DATAAI,
  QUESTIONS as QUESTIONS_DATAAI,
  ARTICLES as ARTICLES_DATAAI
} from  './dataai'

export const BUNDLE_ACRONYMS = {
  'aigp': ACRONYMS_AIGP,
  'awscaip': ACRONYMS_AWSCAIP,
  'awsmle': ACRONYMS_AWSMLE,
  'ghcpc': ACRONYMS_GHCPC,
  'secaiplus': ACRONYMS_SECAIPLUS,
  'dataai': ACRONYMS_DATAAI
}
export const BUNDLE_GLOSSARY = {
  'aigp': GLOSSARY_AIGP,
  'awscaip': GLOSSARY_AWSCAIP,
  'awsmle': GLOSSARY_AWSMLE,
  'ghcpc': GLOSSARY_GHCPC,
  'secaiplus': GLOSSARY_SECAIPLUS,
  'dataai': GLOSSARY_DATAAI
}
export const BUNDLE_FLASHCARDS = {
  'aigp': FLASHCARDS_AIGP,
  'awscaip': FLASHCARDS_AWSCAIP,
  'awsmle': FLASHCARDS_AWSMLE,
  'ghcpc': FLASHCARDS_GHCPC,
  'secaiplus': FLASHCARDS_SECAIPLUS,
  'dataai': FLASHCARDS_DATAAI
}
export const BUNDLE_QUESTIONS = {
  'aigp': QUESTIONS_AIGP,
  'awscaip': QUESTIONS_AWSCAIP,
  'awsmle': QUESTIONS_AWSMLE,
  'ghcpc': QUESTIONS_GHCPC,
  'secaiplus': QUESTIONS_SECAIPLUS,
  'dataai': QUESTIONS_DATAAI
}
// AICerts ships each cert as a single combined module (articles ride with questions, which
// stay eager), so articles can't be split into their own chunk here — LOAD_ARTICLES just
// returns the already-bundled data. Interface kept uniform with split-content brands.
const ARTICLE_DATA = {
  'aigp': ARTICLES_AIGP,
  'awscaip': ARTICLES_AWSCAIP,
  'awsmle': ARTICLES_AWSMLE,
  'ghcpc': ARTICLES_GHCPC,
  'secaiplus': ARTICLES_SECAIPLUS,
  'dataai': ARTICLES_DATAAI
}

export const LOAD_ARTICLES = async (cert) => ARTICLE_DATA[cert] || []

export const BUNDLE_ARTICLE_COUNTS = {
  'aigp': (ARTICLES_AIGP || []).length,
  'awscaip': (ARTICLES_AWSCAIP || []).length,
  'awsmle': (ARTICLES_AWSMLE || []).length,
  'ghcpc': (ARTICLES_GHCPC || []).length,
  'secaiplus': (ARTICLES_SECAIPLUS || []).length,
  'dataai': (ARTICLES_DATAAI || []).length
}

export const GET_TOTAL_QUESTIONS = (certificate) => {
  if (certificate == 'aigp') {
    return  QUESTIONS_AIGP.length;
  }
  else if (certificate == 'awscaip') {
    return  QUESTIONS_AWSCAIP.length;
  }
  else if (certificate == 'awsmle') {
    return  QUESTIONS_AWSMLE.length;
  }
  else if (certificate == 'ghcpc') {
    return  QUESTIONS_GHCPC.length;
  }
  else if (certificate == 'secaiplus') {
    return  QUESTIONS_SECAIPLUS.length;
  }
  else if (certificate == 'dataai') {
    return  QUESTIONS_DATAAI.length;
  }
  return QUESTIONS_AIGP.length;
}
